// Named imports only — `import * as Sentry` defeats tree-shaking and drags
// the unused Replay/Feedback/Canvas modules (~60KB) into the main bundle.
import { init, setUser, captureException, captureMessage } from '@sentry/browser';

// DSN + env come from <meta> tags rendered by the Blade layout (server config),
// so the same Sentry project/DSN drives PHP and JS with no build-time env.
const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content;

if (dsn) {
    init({
        dsn,
        environment: document.querySelector('meta[name="sentry-env"]')?.content || 'production',
        release: document.querySelector('meta[name="sentry-release"]')?.content || undefined,
        // Errors only by default — no performance tracing (turn up if wanted).
        tracesSampleRate: 0,
        sendDefaultPii: true,
        ignoreErrors: [
            'Non-Error promise rejection captured',
            'ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications.',
        ],
    });

    const uid = document.querySelector('meta[name="sentry-user"]')?.content;
    if (uid) setUser({ id: uid });

    // Expose for inline scripts (e.g. drawer PayPal onError) to capture manually.
    window.Sentry = { captureException, captureMessage };
}
